<template>
  <div>
    <b-container fluid>
      <h1>プロパティ設計</h1>
      <button
        class="btn btn-outline-secondary"
        @click="confirmStart = !confirmStart"
      >スタート</button>
      <router-link
        class="btn btn-outline-secondary"
        to="/"
      >戻る</router-link>
      <div v-for="process in processes" :key="process.name">
        <b-row align-v="center">
          <b-col>
            <b-spinner
              v-if="process.status === 0"
              variant="secondary"
              type="grow"
            ></b-spinner>
            <b-spinner
            v-if="process.status === 1"
              variant="success"
            ></b-spinner>
            <v-icon
              v-if="process.status === 2"
              size="40"
              class="done_circle"
            >mdi-check-circle-outline</v-icon>
            <span class="left_space">{{ process.translate }}</span>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <PropertyList />
    <b-modal
      v-model="confirmStart"
      hide-footer
    >
      <b-row align-h="center">
        <p>作成してよろしいですか。</p>
      </b-row>
      <b-row align-h="around" >
        <button
          class="btn btn-outline-secondary"
          @click="startDesign"
        >はい</button>
        <button
          class="btn btn-outline-danger"
          @click="confirmStart = !confirmStart"
        >いいえ</button>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import { API, graphqlOperation } from 'aws-amplify'
import { mapState } from 'vuex'
import PropertyList from '../list/Properties.vue'
export default {
  name: 'ProgressProperty',
  components: {
    PropertyList
  },
  data () {
    return {
      status: '',
      job_id: '',
      confirmStart: false,
      processes: [
        {
          name: 'PropertyDesignAccepted',
          translate: 'プロパティ設計開始',
          status: 0
        },
        {
          name: 'SystemDesign',
          translate: 'システム設計',
          status: 0
        },
        {
          name: 'SteadyCommunication',
          translate: '定常通信',
          status: 0
        },
        {
          name: 'InitialProperty',
          translate: '初期プロパティ',
          status: 0
        },
        {
          name: 'CommunicationFrequencyDesign',
          translate: '通信頻度',
          status: 0
        },
        {
          name: 'SplitDestination',
          translate: '宛先分割',
          status: 0
        },
        {
          name: 'PropertyIntegration',
          translate: 'プロパティ結合',
          status: 0
        },
        {
          name: 'PropertyDesignCompletion',
          translate: 'プロパティ設計完了',
          status: 0
        }
      ],
      latest_done: '',
      eachStatus: ['waiting', 'working', 'completed']
    }
  },
  methods: {
    checkProgress () {
      let lastestDoneIndex = 0
      this.processes.forEach(function (elm, index) {
        if (elm.name === this.latest_done) {
          lastestDoneIndex = index
        }
      }.bind(this))
      this.processes.forEach(function (elm, index) {
        if (index <= lastestDoneIndex) {
          elm.status = 2
        } else if (index === lastestDoneIndex + 1) {
          elm.status = 1
        } else {
          elm.status = 0
        }
      })
    },
    async startDesign () {
      this.confirmStart = false
      const result = await API.graphql(graphqlOperation(`
        mutation createDesign {
          createPropertyDesign(version: "${this.version}"){
            job_id
            status
          }
        }
      `))
      this.$log.debug(result)
      this.job_id = result.data.createPropertyDesign.job_id
      this.$store.commit('updateJobId', result.data.createPropertyDesign.job_id)
      await API.graphql(graphqlOperation(`
        subscription updateJobSubscription {
          onUpdatePropertyDesign(job_id:"${this.job_id}"){
            status
            job_id
          }
        }
      `)
      ).subscribe({
        next: function (eventData) {
          this.$log.debug('=== Event Data ===', eventData)
          this.latest_done = eventData.value.data.onUpdatePropertyDesign.status
        }.bind(this)
      })
      await setTimeout((subscription) => {
        subscription.unsubscribe()
      }, 300000) // 10分
    }
  },
  watch: {
    latest_done: function (newValue) {
      this.checkProgress()
      if (newValue === 'PropertyDesignCompletion') {
        this.$store.commit('updateCompletedJob', 'property')
      }
    }
  },
  computed: {
    ...mapState(['version'])
  }
}
</script>
<style>
  .left_space{
    margin-left: 1rem;
  }
</style>
